







































































































import { Component, Mixins, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import FireStoreMixin from "#/mixins/firestoreMixin";
import { VForm, Choice } from "@/types";
import * as appDate from "#/utility/appDate";
import { ListIndex } from "@/views/aivnplan/types";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { COLLECTION_AI_INDEX } from "@/consts/envFireStore";
import { ListDataset } from "@/views/aivnplan/types";

interface BatchSetting {
  /** データセットID */
  dataset_id: number;
  /** ON/OFFフラグ */
  enable: boolean;
  /** 最大処理件数 */
  process_limit: number;
}

@Component({
  components: {
    AppAuthButton,
  },
})
/** 計画書自動作成 インデックス自動作成条件設定 */
export default class IndexBatchConfig extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin,
  FireStoreMixin
) {
  /** Ref */

  /** バッチ処理設定フォーム操作用 */
  @Ref("batch-form") private readonly batchForm!: VForm;

  /** 変数 */

  /** データセットID */
  private datasetId = 0;

  /** 指定年月 */
  private yearmonth = appDate.thisMonth();

  /** 最大処理件数 */
  private processLimit = 500;

  /** データセット選択肢 */
  private datasetChoice: Choice[] = [];

  /** フィルター用キーワード */
  private searchKeyword = "";

  /** 1ページあたりの表示件数 */
  private itemPerPage = 25;

  /** 表の現在のページ数 */
  private pageNo = 1;

  /** データセット */
  private datasets: ListDataset[] = [];

  /** データテーブル用ヘッダー */
  private headers = [
    {
      text: "データセット名",
      align: "start",
      value: "name",
      filterable: true,
      sortable: false,
    },
    {
      text: "コメント",
      align: "start",
      value: "comment",
      filterable: true,
      sortable: false,
    },
    {
      text: "最終更新者",
      align: "start",
      value: "editor_admin_name",
      filterable: false,
      sortable: false,
    },
    {
      text: "最終更新日時",
      align: "start",
      value: "updated_at",
      filterable: false,
    },
    {
      text: "",
      value: "actions",
      sortable: false,
      align: "end",
    },
  ];

  /** バッチ処理設定 */
  private batchSetting: BatchSetting = {
    dataset_id: 0,
    enable: false,
    process_limit: 500,
  };

  /** 関数 */

  async created() {
    this.fetch();
    this.fetchDataset();

    this.collection = COLLECTION_AI_INDEX;
    this.documentId = "admin";
    const data = await this.documentGet();
    if (data) {
      this.batchSetting = data as BatchSetting;
    } else {
      this.batchSetting.dataset_id = this.datasetChoice[0].value;
    }
  }

  /** 取得 */
  private fetch() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/index/form/get",
      {},
      async (res) => {
        this.datasetChoice = res.data.dataset_choice;

        // 先頭の選択肢を選択した状態にしておく
        if (this.datasetChoice && this.datasetChoice.length > 0) {
          this.datasetId = this.datasetChoice[0].value;
        }
      }
    );
  }

  /** 表のページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  /** バッチ処理設定（データセット）バリデーション */
  private checkBatchSettingDataset(): boolean | string {
    if (!this.batchSetting.enable) {
      return true;
    }

    if (this.batchSetting.dataset_id == 0) {
      return "データセットを選択する必要があります。";
    }

    return true;
  }

  /** バッチ処理設定（最大処理件数）バリデーション */
  private checkBatchSettingProcessLimit(): boolean | string {
    if (!this.batchSetting.enable) {
      return true;
    }

    if (this.batchSetting.process_limit == 0) {
      return "最大処理件数を1件以上に設定する必要があります。";
    }

    return true;
  }

  /** バッチ処理設定保存 */
  private async saveBatchSetting() {
    if (!this.batchForm.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }

    this.documentSave(this.batchSetting);
    await this.$openAlert("設定を保存しました。");

    this.moveToIndexConfigPage();
  }

  /** キャンセル */
  private cancel() {
    this.moveToIndexConfigPage();
  }

  /** インデックス設定画面へ遷移 */
  private moveToIndexConfigPage() {
    this.$router.push({ path: "/ai-vnplan/index/config" });
  }

  /** データセット取得 */
  private fetchDataset() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/datasets/get",
      {},
      async (res) => {
        this.datasets = res.data.datasets;
      }
    );
  }

  /** データセット編集画面へ遷移 */
  private moveDatasetEditPage(id: number) {
    this.$router.push({
      path: `/ai-vnplan/dataset/edit/${id}`,
      query: { fromType: "2" },
    });
  }
}
